/**
 * @generated SignedSource<<8a0439e5dc871904d7f52d3643bc7c68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectListPage_customFieldValues$data = {
  readonly projectListCustomFields: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly key: string;
        readonly value: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProjectListPage_customFieldValues";
};
export type ProjectListPage_customFieldValues$key = {
  readonly " $data"?: ProjectListPage_customFieldValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectListPage_customFieldValues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectListPage_customFieldValues",
  "selections": [
    {
      "alias": "projectListCustomFields",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        },
        {
          "kind": "Literal",
          "name": "list",
          "value": "PROJECT_LIST"
        }
      ],
      "concreteType": "CustomFieldValueV2TypeConnection",
      "kind": "LinkedField",
      "name": "customFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomFieldValueV2TypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "customFields(first:1000,list:\"PROJECT_LIST\")"
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "93d813ce9c2e1ad46e4d8fe0a8a0a22f";

export default node;
